export function target() {
  return this.module === 'PageSettings';
}

export function migrate() {
  if (this.data.indexing === undefined) {
    this.data.indexing = true;
  }
}
